/* Wspólne style i stałe dla sekcji ContentEditor. */
export const inputCls =
  "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-800 focus:border-[#1f3a8a] focus:ring-1 focus:ring-[#1f3a8a] outline-none";

export const labelCls = "text-[11px] font-bold text-slate-500 uppercase tracking-wider";

export const SECTIONS = [
  { id: "marka", label: "Marka i kontakt", preview: "/" },
  { id: "menu", label: "Górne menu (nazwy)", preview: "/" },
  { id: "call", label: "Pływający przycisk „Zadzwoń teraz”", preview: "/" },
  { id: "discounts", label: "Kody rabatowe (rabaty)", preview: "/" },
  { id: "home", label: "Strona główna – teksty", preview: "/" },
  { id: "plany", label: "Abonamenty telefoniczne", preview: "/abonamenty" },
  { id: "mi", label: "Internet mobilny – pakiety", preview: "/abonamenty" },
  { id: "kody", label: "Kody paczek USSD", preview: "/abonamenty" },
  { id: "internet", label: "Podstrona Internet mobilny", preview: "/internet-mobilny" },
  { id: "podstrony", label: "Inne podstrony (Kontakt / SIM / Przenieś)", preview: "/kontakt" },
  { id: "regulamin", label: "Regulamin", preview: "/regulamin" },
  { id: "rodo", label: "RODO – klauzula informacyjna", preview: "/rodo" },
  { id: "cookies", label: "Polityka cookies (tekst)", preview: "/polityka-cookies" },
  { id: "footer", label: "Stopka (kolumny i linki)", preview: "/" },
  { id: "placements", label: "Pływające grafiki (drag & drop)", preview: "/" },
  { id: "logo", label: "Logo", preview: "/" },
];

// Podstrony, na które można nakładać pływające grafiki
export const PLACEMENT_PAGES = [
  { id: "home", label: "Strona główna", url: "/" },
  { id: "plans", label: "Abonamenty", url: "/abonamenty" },
  { id: "internet", label: "Internet mobilny", url: "/internet-mobilny" },
  { id: "zamow-sim", label: "Zamów SIM", url: "/zamow-sim" },
  { id: "przenies-numer", label: "Przenieś numer", url: "/przenies-numer" },
  { id: "kontakt", label: "Kontakt", url: "/kontakt" },
  { id: "regulamin", label: "Regulamin", url: "/regulamin" },
  { id: "rodo", label: "RODO", url: "/rodo" },
];

export const ICON_OPTIONS = [
  { value: "signal", label: "Sygnał" },
  { value: "shield", label: "Tarcza" },
  { value: "zap", label: "Prędkość" },
  { value: "globe", label: "Globus" },
  { value: "wifi", label: "Wi-Fi" },
];

export const MENU_ICON_OPTIONS = [
  { value: "star", label: "Gwiazdka" },
  { value: "gift", label: "Prezent" },
  { value: "percent", label: "Procent (promocja)" },
  { value: "info", label: "Informacja" },
  { value: "help", label: "Pomoc" },
  { value: "book", label: "Książka" },
  { value: "shield", label: "Tarcza" },
  { value: "globe", label: "Globus" },
  { value: "link", label: "Link zewnętrzny" },
  { value: "file", label: "Dokument" },
];

export const EMPTY_BRAND = {
  tagline: "",
  logo_url: "",
  coverage_card_visible: true,
  coverage_card_opacity: 0.92,
  discount_codes_enabled: false,
  hero: { eyebrow: "", title: "", subtitle: "", cta_port_enabled: true },
  hero_eyebrow_style: { size: "md", flag_speed_sec: 12 },
  hero_title_style: { font_family: "manrope", size: "3xl", weight: 900, italic: false },
  countdown: { enabled: true, label: "Start za", target_at: "2026-12-01T00:00:00" },
  sales_lock_enabled: true,
  contact: { email: "", phone: "", address: "", hours: "" },
  coverage: { label: "", title: "", subtitle: "" },
  plans_heading: { eyebrow: "", title: "", subtitle: "" },
  features: [],
  top_features: [],
  cta_home: {
    title: "",
    subtitle: "",
    primary_btn: { enabled: true, text: "Zamów kartę SIM", url: "/zamow-sim" },
    secondary_btn: { enabled: false, text: "Przenieś numer", url: "/przenies-numer" },
  },
  floating_call: { enabled: true, label: "Zadzwoń teraz" },
  menu: {
    show_home: true,
    show_plans: true,
    show_internet: true,
    show_order_sim: true,
    show_port_number: true,
    show_contact: false,
    cta_enabled: true,
    cta_url: "/zamow-sim",
    labels: {
      home: "Start",
      plans: "Abonamenty",
      internet: "Internet mobilny",
      order_sim: "Zamów SIM",
      port_number: "Przenieś numer",
      contact: "Kontakt",
      cta: "Zamów teraz",
    },
    custom_pages: [],
  },
  footer_columns: [],
};

export const EMPTY_PAGES = {
  internet: { eyebrow: "", hero_title: "", hero_subtitle: "", bullets: [], cta_button: "", show_featured: true },
  regulamin: { title: "", subtitle: "", body: "" },
  extra_internet: { eyebrow: "", title: "", subtitle: "", col_code: "", col_size: "", col_price: "", note_bottom: "" },
  contact: { eyebrow: "", title: "", subtitle: "" },
  order_sim: { eyebrow: "", title: "", subtitle: "", success_title: "", success_message: "", number_type_title: "Numer telefonu", number_type_new_label: "Nowy numer telefonu", number_type_port_label: "Przenieś numer telefonu", number_type_port_help: "Podaj numer, który chcesz przenieść do naszej sieci." },
  port_number: { eyebrow: "", title: "", subtitle: "", success_title: "", success_message: "" },
  cookie_policy: { title: "", subtitle: "", body: "" },
  rodo: { title: "", subtitle: "", intro: "", body: "" },
  payment: { success_title: "", success_message: "", cancel_title: "", cancel_message: "" },
};
